<script>

import axios from 'axios'

export default {
  data() {
    return {
      state: 'unsubmitted',
      emailConfirm: '',
      emailsDoNotMatch: false,
      image: null,
      message: {
        email: '',
        subject: '',
        message: '',
        type_of_question: 'general',
        location: 'usa',
        file_upload: null
      },
      errors: {},
    }
  },
  mounted() {
  },
  props: ['token', 'endpoint', 'location'],
  computed: {
    unsubmitted() {
      return this.state == 'unsubmitted'
    },
    sending() {
      return this.state == 'sending'
    },
    sent() {
      return this.state == 'sent'
    },
    emailValid() {
      return (!this.message.email.length || (this.message.email.length && this.message.email == this.emailConfirm)) ? true : false
    },
    api() {
      return axios.create({
        headers: {
          'Authorization': 'Token token=' + this.token,
          'Content-Type': 'application/json'
        }
      })
    },
  },
  methods: {
    submit() {
      this.emailsDoNotMatch = false
      if (this.emailValid) {
        this.state = 'sending'
        let data = window._.clone(this.message);

        if (this.location.length) {
          data.message += '\n\n--------\nSent From: ' + this.location;
        }

        this.api.post(this.endpoint, {'contact_message': data})
          .then((response) => {
            this.state = 'sent'
          }, (error) => {
            this.errors = error.response.data
            this.state = 'unsubmitted'
          })
      } else {
        this.emailsDoNotMatch = true
      }
    },
    hasError(field) {
      let data = false
      for (let key of Object.keys(this.errors)) {
        if (field == key) {
          data = true
          break
        }
      }
      return data
    },
    unsetForm() {
      this.$set(this.message, 'email', '');
      this.$set(this.message, 'subject', '');
      this.$set(this.message, 'message', '');
      this.$set(this.message, 'type_of_question', 'general');
      this.$set(this.message, 'location', 'usa');
      this.emailConfirm = ''
      this.state = 'unsubmitted'
    },
    uploadFile() {
      this.createBase64Image(this.$refs.file_upload.files[0]);
    },
    createBase64Image(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.$set(this.message, 'file_upload', reader.result);
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
  }
}
</script>
